const BASE_URL = "https://static.neshan.org";
const DEFAULT_URL = `${BASE_URL}/sdk/leaflet/1.4.0/leaflet.js`;
const DEFAULT_URL_STYLE = `${BASE_URL}/sdk/leaflet/1.4.0/leaflet.css`;

export default (onLoad: any, onError: any) => {
    const createScript = () => {

        const styleLeaflet = document.getElementById("style-leaflet");
        styleLeaflet && styleLeaflet.remove();

        const scriptLeaflet = document.getElementById("script-leaflet");
        scriptLeaflet && scriptLeaflet.remove();

        const style = document.createElement("link");
        style.href = DEFAULT_URL_STYLE;
        style.rel = "stylesheet";
        style.setAttribute("id", "style-leaflet");
        document.head.appendChild(style);

        const script = document.createElement("script");
        script.src = DEFAULT_URL;
        script.setAttribute("defer", "defer");
        script.setAttribute("id", "script-leaflet");
        script.onload = () => onLoad();
        script.onerror = () => onError();
        document.head.appendChild(script);
    };

    return createScript();
};
